export const handleSkipToNextSection = async ({
  setActiveIndex,
  activeIndex,
  setDataError,
  setError,
  setSectionError,
  setIsShowCreateForm,
}) => {
  setActiveIndex({
    sectionIndex: activeIndex.sectionIndex + 1,
    propertyIndex: 0,
  });
  window.scrollTo(0, 0);
  setDataError({});
  setError('');
  setSectionError('');
  setIsShowCreateForm(1);
};
